<script>

  import {onMount,onDestroy, getContext} from 'svelte';
  import { currentView } from '../store';
  import Template from '../components/Template.svelte';

  export let view
  
  //let title = "Not found";

  let comp;
  let ready =false;
  
  let height = document.body && document.body.clientHeight && document.body.clientHeight >0 ? document.body.clientHeight : screen.height;  
  let ver = 100;

  onMount(async () => {
    if(view){
      if(view.id > -1){
        //console.log(view)
        
        if(typeof(moduleVersions) !== 'undefined' ){
          const v = moduleVersions.find(x=> x.JsPath === view.m);
          //console.log(view.m +" ver")
          //console.log(v)
          if(v && v !==undefined){
            ver = v.ModuleVersion;
          }

        }else{
          ver = tempVer
        }

        let template =templatePath +'/public/modules/'+ view.m + '/index.mjs?v=' + ver;
        
        if(test){
          template = testTemplatePath +'/public/modules/'+ view.m + '/test/index.mjs?v=' + ver;
        }
        
      
        //title = view.t;
        const module = await import(template);
        
        comp = module.default;
        const viewobj = document.querySelector('.view');
        height = viewobj.clientHeight;
        ready = true;

   
      }
    }
  });
  

  async function templateReady(){
    
    const index = views.findIndex(x=> x.id == view.id);
    views[index].loaded = true;
    
    console.log('template '+ view.id + ' ready')
  }

</script>

<!-- <Header name={title} {back} {animateIt}/> -->
<div class="view-content">
  {#if ready && ( $currentView === view.id || view.loaded === true )}
    <Template {comp} {view} on:mounted={templateReady} {height}/>
  {/if}
</div>


<style>
  .view-content{
      display: flex;
      min-height:100%;
      height: 100%;
      min-width:100%;
      /* overflow-x: hidden;
      overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain; */
  }
</style>